import React from 'react';

import {motion} from 'framer-motion';
import {useIntl} from 'react-intl';

export const ClipItOnSection: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const intl = useIntl();

  return (
    <section className="relative w-full bg-white overflow-hidden py-12 lg:py-16">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Side - Text Content */}
          <motion.div
            className="text-center lg:text-left"
            initial={{opacity: 0, x: -30}}
            whileInView={{opacity: 1, x: 0}}
            viewport={{once: true, margin: '-100px'}}
            transition={{duration: 0.6}}
          >
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-neutral-900 mb-4 lg:mb-6">
              {intl.formatMessage({id: 'home.clipItOnSection.title'})}
            </h2>
            <p className="text-lg lg:text-xl text-neutral-600 leading-relaxed">
              {intl.formatMessage({id: 'home.clipItOnSection.description'})}
            </p>
          </motion.div>

          {/* Right Side - Image */}
          <motion.div
            className="relative"
            initial={{opacity: 0, x: 30}}
            whileInView={{opacity: 1, x: 0}}
            viewport={{once: true, margin: '-100px'}}
            transition={{duration: 0.6, delay: 0.2}}
          >
            <div className="relative rounded-2xl overflow-hidden shadow-lg">
              <img
                src="/images/home/clip-it-on.jpg"
                alt="Stryd clipped to a running shoe"
                className="w-full h-auto object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
